/* Frague: small behaviours on top of Dawn. No storage, no tracking. */
(function () {
  'use strict';

  /* ---------- Pincode check (product page) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-fr-pin-form]');
    if (!form) return;
    e.preventDefault();
    var box = form.closest('[data-fr-pin]');
    var input = form.querySelector('input');
    var out = box.querySelector('[data-fr-pin-result]');
    var notify = box.querySelector('[data-fr-pin-notify]');
    var v = input.value.trim();
    if (!/^\d{6}$/.test(v)) {
      input.setAttribute('aria-invalid', 'true');
      out.textContent = 'Enter a 6-digit pincode.';
      if (notify) notify.hidden = true;
      return;
    }
    input.removeAttribute('aria-invalid');
    if (v.indexOf(box.dataset.prefix || '110') === 0) {
      out.textContent = 'Delivers to Delhi. Estimated ' + (box.dataset.days || '2–4') + ' days.';
      if (notify) notify.hidden = true;
    } else {
      out.textContent = 'We deliver in Delhi first. Leave your email and we will tell you when we reach ' + v + '.';
      if (notify) {
        notify.hidden = false;
        var body = notify.querySelector('[data-fr-pin-body]');
        if (body) body.value = 'Pincode waitlist: ' + v;
      }
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-fr-pin-form] input')) {
      e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6);
    }
  });

  /* ---------- Sticky add-to-cart bar (product page, phones) ---------- */
  function initBuybar() {
    var bar = document.querySelector('[data-fr-buybar]');
    if (!bar) return;
    var mainSubmit = document.querySelector('.product-form__submit[name="add"]');
    if (!mainSubmit) return;

    bar.querySelector('[data-fr-buybar-add]').addEventListener('click', function () {
      if (mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true') {
        mainSubmit.scrollIntoView({ block: 'center' });
        return;
      }
      mainSubmit.click();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(mainSubmit);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      var fmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var variant = evt && evt.data && evt.data.variant;
        if (!variant) return;
        var meta = bar.querySelector('[data-fr-buybar-meta]');
        if (meta) meta.textContent = variant.title + ', ' + fmt.format(variant.price / 100);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBuybar);
  else initBuybar();
})();
